// extracted by mini-css-extract-plugin
export default {"Layer":"📚19-10-2_4EhS","DialogLayer":"📚19-10-2_5MSu","DialogContentWrapper":"📚19-10-2aXIC6","Translucent":"📚19-10-2FHIJw","disableScroll":"📚19-10-2n_iBq"};